import { useAppSelector } from '../../hooks';
import {
  ComplianceData,
  ComplianceMetadata,
  ComplianceSection,
} from './compliance.reducer';

export const useGetComplianceActiveStep = (): number =>
  useAppSelector(({ compliance }) => compliance.activeStep);

export const useGetComplianceSections = (): ComplianceSection[] =>
  useAppSelector(({ compliance }) => compliance?.sections);

export const useGetComplianceMetaData = (): ComplianceMetadata =>
  useAppSelector(({ compliance }) => compliance.metaData);

export const useGetComplianceData = (): ComplianceData =>
  useAppSelector(({ compliance }) => ({
    metaData: compliance.metaData,
    sections: compliance.sections,
  }));

export const useGetComplianceSectionData = (index: number): ComplianceSection =>
  useAppSelector(({ compliance }) => compliance?.sections?.[index]);
